/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type KnowledgeHubApi from 'embercom/lib/knowledge-hub/list-api';
import AllContent from 'embercom/controllers/apps/app/knowledge-hub/all-content';
import type Folder from 'embercom/models/content-service/folder';

export default class AutomationFinAIAgentContentFolderController extends AllContent {
  declare listApi: KnowledgeHubApi;
  declare folder: Folder;
}
